import teacher from '@/api/teacher-profile'
import Employee from '@/api/employee'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  nationalities: [],
  activate_types: [],
  main_programs: [],
  sub_programs: [],
  subjects: [],
  provinces: [],
  positions: [],
  photo_exists: null,
  shifts: []
}

export const getters = {
  getSubPrograms: state => acp_id => {
    if (!acp_id) {
      return []
    }
    return state.sub_programs.filter(s => s.acp_id === acp_id)
  },
  getSubject: state => acps_id => {
    if (!acps_id) {
      return []
    }
    return state.subjects.filter(s => s.acps_id === acps_id)
  }
}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_NATIONALITY(state, nationality) {
    state.nationalities = nationality
  },
  SET_ACTIVATE_TYPE(state, activat_types) {
    state.activate_types = activat_types
  },
  SET_MAIN_PROGRAM(state, main_program) {
    state.main_programs = main_program
  },
  SET_SHIFTS(state, data) {
    state.shifts = data
  },
  SET_POSITIONS(state, data) {
    state.positions = data
  },
  SET_PROVINCE(state, provinces) {
    state.provinces = provinces
  },
  SET_SUBPROGRAM(state, sub_program) {
    if (sub_program.length > 0) {
      state.sub_programs.push(...sub_program)
      state.sub_programs = _.uniqBy(state.sub_programs, 'acps_name_foreign')
    }
  },
  SET_SUBJECT(state, subject) {
    if (subject.length > 0) {
      state.subjects.push(...subject)
    }
  },
  SET_PHOTO_EXISTS(state, data) {
    state.photo_exists = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        photo_exists: context.state.photo_exists
      },
      attrubutes
    )
    return teacher.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return teacher.store(data)
  },

  update(context, data) {
    return teacher.update(data)
  },

  destroy(context, id) {
    return teacher.destroy(id)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await teacher.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  district(context, province_code) {
    if (province_code) {
      return teacher.district(province_code)
    }
    return { data: [] }
  },

  commune(context, district_code) {
    if (district_code) {
      return teacher.commune(district_code)
    }
    return { data: [] }
  },
  village(context, commune_code) {
    if (commune_code) {
      return teacher.village(commune_code)
    }
    return { data: [] }
  },

  schedule(context, teacher_id) {
    return teacher.schedule(teacher_id)
  },

  fetchEmolyee(context, attributes = {}) {
    let params = {
      page: -1,
      search: attributes,
      fields: {
        setup_staff_information:
          'staff_id,name_kh,name_en,date_of_birth,phone_number_1,gender,position_id,email,shift_id,province_code,district_code,commune_code,village_code,marital_status,photo'
      },
      filter: { not_in_registered_to_teacher: true },
      include: 'position,shift',
      ...attributes
    }

    return Employee.get({ params }).then(response => {
      return Promise.resolve(response)
    })
  },

  async subProgram(context, acp_id) {
    let count = context.state.sub_programs.filter(s => s.acp_id === acp_id)
    if (!count.length) {
      let response = await teacher.subProgram(acp_id)
      context.commit('SET_SUBPROGRAM', response.data)
      return response
    }
  },
  async subject(context, acps_id) {
    let count = context.state.subjects.filter(s => s.acps_id === acps_id)
    if (!count.length > 0) {
      let response = await teacher.subject(acps_id)
      context.commit('SET_SUBJECT', response.data)
      return response
    }
  },

  async uploadPhoto(context, data) {
    return await teacher.uploadPhoto(data)
  },

  async dataBeforeCreate(context) {
    if (!context.state.nationalities.length > 0) {
      let response = await teacher.nationality()
      context.commit('SET_NATIONALITY', response.data)
    }
    if (!context.state.activate_types.length > 0) {
      let response = await teacher.activateType()
      context.commit('SET_ACTIVATE_TYPE', response.data)
    }
    if (!context.state.main_programs.length > 0) {
      let response = await teacher.mainProgram()
      context.commit('SET_MAIN_PROGRAM', response.data)
    }
    if (!context.state.provinces.length > 0) {
      let response = await teacher.province()
      context.commit('SET_PROVINCE', response.data)
    }
    if (!context.state.shifts.length > 0) {
      let response = await teacher.getShift()
      context.commit('SET_SHIFTS', response.data)
    }
    if (!context.state.positions.length > 0) {
      let response = await teacher.position()
      context.commit('SET_POSITIONS', response)
    }
  },

  printCard(context, data) {
    return teacher.printCard({
      params: {
        side: data.side,
        teacher_id_list: data.teacher_id_list,
        type: data.type
      }
    })
  },
  // generate student list as excel
  exportExcel(context, data) {
    return teacher.exportExcel(data)
  },
}
